const PendoTracking = (visitor, account) => {
  try {
    typeof window.pendo === 'object' &&
      typeof window.pendo.initialize === 'function' &&
      window.pendo.initialize({
        visitor,
        account
      })
  } catch (e) {
    console.error('### error', e)
  }
}

export default PendoTracking

export const pendoTrack = (message, payload) => {
  try {
    window.pendo &&
      typeof window.pendo.track === 'function' &&
      window.pendo.track(message, payload)
  } catch {}
}
